import { render, staticRenderFns } from "./ThankYouDialog.vue?vue&type=template&id=a284d6a2"
import script from "./ThankYouDialog.vue?vue&type=script&lang=js"
export * from "./ThankYouDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports